import { cn } from "@/lib/utils";

// #design-pass: kleiner Status-Punkt mit tone-Glow (System-Status, Live-Indikatoren).
type Tone = "ok" | "info" | "warn" | "danger" | "muted";

export function StatusDot({ tone = "muted", pulse = false }: { tone?: Tone; pulse?: boolean }) {
  const color =
    tone === "ok" ? "bg-ok" : tone === "info" ? "bg-info" : tone === "warn" ? "bg-warn" : tone === "danger" ? "bg-danger" : "bg-text3";
  return (
    <span
      className={cn(
        "inline-block h-2 w-2 shrink-0 rounded-full",
        color,
        tone !== "muted" && "shadow-[0_0_0_3px_color-mix(in_srgb,currentColor_18%,transparent)]",
        pulse && "animate-pulse",
      )}
      style={tone !== "muted" ? { color: `var(--${tone})` } : undefined}
    />
  );
}
